import { use, useContext } from "react";
import AuthContext from "../context/authContext";

export default () => useContext(AuthContext);